"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ThemeContext = React.createContext({
    theme: "",
    setTheme: null
});
exports.ThemeContext = ThemeContext;
var ThemeManager = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeManager, _super);
    function ThemeManager(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setTheme = function (themeName, enabled) {
            _this.setState({ currentTheme: enabled ? themeName : "" }, function () { return _this.handleState(themeName, enabled); });
        };
        _this.state = { currentTheme: _this.getThemeValue() };
        _this.handleState(_this.state.currentTheme, !!_this.state.currentTheme);
        return _this;
    }
    ThemeManager.prototype.getThemeValue = function () {
        var themeStorageKey = this.props.themeStorageKey;
        return localStorage.getItem(themeStorageKey) || "";
    };
    ThemeManager.prototype.persistThemeValue = function (themeName) {
        var themeStorageKey = this.props.themeStorageKey;
        localStorage.setItem(themeStorageKey, themeName);
    };
    ThemeManager.prototype.clearThemeValue = function () {
        var themeStorageKey = this.props.themeStorageKey;
        localStorage.removeItem(themeStorageKey);
    };
    ThemeManager.prototype.applyThemeToDocumentRoot = function (themeName) {
        document.documentElement.classList.add(themeName);
    };
    ThemeManager.prototype.removeThemeFromDocumentRoot = function (themeName) {
        if (themeName && document.documentElement.classList.contains(themeName)) {
            document.documentElement.classList.remove(themeName);
        }
    };
    ThemeManager.prototype.handleState = function (themeName, enabled) {
        if (enabled) {
            this.persistThemeValue(themeName);
            this.applyThemeToDocumentRoot(themeName);
        }
        else {
            this.clearThemeValue();
            this.removeThemeFromDocumentRoot(themeName);
        }
    };
    ThemeManager.prototype.render = function () {
        var children = this.props.children;
        var currentTheme = this.state.currentTheme;
        return (React.createElement(ThemeContext.Provider, { value: { theme: currentTheme, setTheme: this.setTheme } }, children));
    };
    ThemeManager.defaultProps = {
        themeStorageKey: "vdz.theme",
    };
    return ThemeManager;
}(React.Component));
exports.default = ThemeManager;
